<template>
  <div>
    <input type="hidden" :name="id" :value="content" />
    <vue-editor :id="id" :name="id" :editorToolbar="customToolbar" v-model="content"></vue-editor>
  </div>
</template>

<style>
.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6,
.ql-editor ol,
.ql-editor p,
.ql-editor pre,
.ql-editor ul {
  white-space: pre-wrap;
  word-break: break-all;
}
</style>

<script>
  import { VueEditor } from 'vue2-editor'

  export default {
    components: {
      VueEditor
    },
    props: {
        id: {
            type: String
        },
        oldcontent:  String,
    },
    data() {
      return {
        content: this.oldcontent,
        customToolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            //['image', 'code-block']
          ]
      }
    }
  }
</script>
